<template>
  <span>{{ showNumber.toFixed(0) }}</span>
</template>

<script>
import gsap from 'gsap'
export default {
  props: {
    number: {
      type: [Number, String],
      default: 0
    },
    delay:{
      type: [Number, String],
      default: 0
    },
  },
  data() {
    return {
      showNumber: 0
    }
  },
  computed: {
    showCounter() {
      return this.showNumber.toFixed(0);
    }
  },
  watch: {
    number:{
      handler(newValue){
        gsap.to(this, {
          duration: 1,
          showNumber: String(newValue),
          delay: this.delay // 延迟1秒开始动画
        })
      },
      deep:true,
      immediate:true,
    }
  }
}
</script>

<style scoped></style>